module.exports = __webpack_public_path__ + "img/icon3.c6ec0d39.png";